import { useTranslation } from 'react-i18next';
import { Link, NavLink, Navigate, Outlet } from 'react-router-dom';
import AppShell from '../../components/AppShell';
import StaffLoginForm from '../../components/StaffLoginForm';
import AuthScreen from '../../components/AuthScreen';
import { useAuth } from '../../auth/AuthContext';

const tabStyle = ({ isActive }: { isActive: boolean }): React.CSSProperties => ({
  padding: '6px 12px',
  borderRadius: 999,
  fontSize: 'var(--font-size-label)',
  fontWeight: 700,
  textDecoration: 'none',
  background: isActive ? 'var(--color-primary)' : 'var(--color-primary-soft)',
  color: isActive ? 'var(--color-on-primary)' : 'var(--color-primary-strong)',
});

/** 管理台外殼（**只限 ai85／staff**；其他角色踢返會員區） */
export default function AdminLayout() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <AppShell title={t('admin_title')}>
        <div className="p-6" />
      </AppShell>
    );
  }
  /**
   * 未登入 → 顯示**職員登入表**（email ＋ 密碼）。
   * ⭐ 產品負責人 2026-10-06：唔再 `Navigate to="/login"` —— 因為會員登入頁已經**只准電話**，
   *   職員（只有 email）如果被踢去嗰度就會入唔到後台。職員喺桌面打 `/admin` 就地登入。
   */
  if (!user) {
    return (
      <AuthScreen title={t('admin_title')}>
        <StaffLoginForm />
      </AuthScreen>
    );
  }
  if (user.role !== 'ai85' && user.role !== 'staff') return <Navigate to="/member" replace />;

  return (
    <AppShell title={t('admin_title')}>
      <nav className="flex gap-2 px-4 pt-4 flex-wrap items-center">
        <NavLink to="/admin/members" style={tabStyle}>
          {t('admin_members')}
        </NavLink>
        <NavLink to="/admin/benefits" style={tabStyle}>
          {t('admin_benefits')}
        </NavLink>
        <NavLink to="/admin/news" style={tabStyle}>
          {t('admin_news')}
        </NavLink>
        <NavLink to="/admin/committees" style={tabStyle}>
          {t('admin_committees')}
        </NavLink>
        <NavLink to="/admin/letters" style={tabStyle}>
          {t('admin_letters')}
        </NavLink>
        <NavLink to="/admin/sponsors" style={tabStyle}>
          {t('admin_sponsors')}
        </NavLink>
        <NavLink to="/admin/seating" style={tabStyle}>
          {t('admin_seating')}
        </NavLink>
        <NavLink to="/admin/check-in" style={tabStyle}>
          {t('admin_checkin')}
        </NavLink>
        <NavLink to="/admin/budget" style={tabStyle}>
          {t('admin_budget')}
        </NavLink>
        <NavLink to="/admin/report" style={tabStyle}>
          {t('admin_report')}
        </NavLink>
        <Link to="/member" style={{ ...tabStyle({ isActive: false }), background: 'transparent', color: 'var(--color-text-secondary)' }}>
          {t('admin_back')}
        </Link>
      </nav>
      <div className="p-4">
        <Outlet />
      </div>
    </AppShell>
  );
}
